import { useEffect, useState } from 'react'
import React from "react";
import Application from './presentation/layout/Application'

function App() {

  const [allowedDomain, setAllowedDomain] = useState(true)
  const domains = import.meta.env.VITE_ORIGIN_ALLOWED;
  useEffect(() => {

    let referrer = document.referrer;

    if(import.meta.env.VITE_DEV !== "true"){

      if(referrer !== " " && referrer !== ""){

        var url = new URL(document.referrer)
        setAllowedDomain(domains.includes(url.host));

      }else{
        setAllowedDomain(false);
      }

    }

  }, [])

  if (allowedDomain)
    return <Application />;

  return <div>Not Allowed</div>

}

export default App
